(function () {
  'use strict';

    const cfg = window.DD_CONFIG || {};

    const SHOWROOM_URL          = cfg.showroomUrl      || 'https://maps.app.goo.gl/b847rdJhWYkskBuD8';
    const SHOWROOM_IMG          = cfg.showroomImg      || 'https://cdn.shopify.com/s/files/1/0573/4088/7104/files/de4dd88f3b52ce79639e8f79fe14a114fb83a4f8.png?v=1778083372';
    // PERF (5 Oct 2026): the pickup card shows the photo at ~64px; the 800px one is for the drawer.
    const SHOWROOM_THUMB        = cfg.showroomThumb    || SHOWROOM_IMG;
    const SHOWROOM_NAME         = cfg.showroomName     || 'New Bahru Outlet';
    const SHOWROOM_ADDRESS_LINE_1 = cfg.showroomAddress1 || '58 Kim Yam Road (Factory Block), #01-06';
    const SHOWROOM_ADDRESS_LINE_2 = cfg.showroomAddress2 || 'Singapore 239359';
    const SHOWROOM_TAGLINE      = cfg.showroomTagline  || 'Discover our curated collection in person.';
    const SHOWROOM_HOURS_LABEL  = cfg.hoursLabel       || 'Daily';
    const SHOWROOM_HOURS_VALUE  = cfg.hoursValue       || '11 AM - 9 PM';
    const TIMEZONE = 'Asia/Singapore';
    const GEO_CACHE_KEY = 'dd_geo_country_v1';
    const GEO_API_URL = 'https://ipapi.co/json/';
    const PICKUP_TITLE          = cfg.pickupTitle      || 'Pick up from New Bahru';
    const PICKUP_READY          = cfg.pickupReady      || 'Ready in 1-2 working days';
    const PICKUP_LINK_TEXT      = cfg.pickupLinkText   || 'View details →';
    const DRAWER_TITLE          = cfg.drawerTitle         || 'our showroom';
    const DRAWER_HOURS_TITLE    = cfg.drawerHoursTitle    || 'Opening hours:';
    const DRAWER_CTA            = cfg.drawerCta           || 'GET DIRECTIONS';
    // Headline copy. [day] is replaced with the weekday of the next delivery day.
    const HEADLINE_TOMORROW = cfg.headlineTomorrow || 'Order now — get it from tomorrow onwards';
    const HEADLINE_DAY      = cfg.headlineDay      || 'Order now — get it from [day] onwards';
    const EXPRESS_TEXT      = cfg.expressText      || 'Same day (express) delivery available';
    const EXPRESS_TOOLTIP   = cfg.expressTooltip   || 'For orders placed before 2PM. Excludes weekends/PH.';
    const STANDARD_LABEL    = cfg.standardLabel    || 'Standard';
    const STANDARD_VALUE    = cfg.standardValue    || '1-5 business days';
    const CHECKOUT_NOTE     = cfg.checkoutNote     || 'Choose your delivery speed at checkout';
    const PUBLIC_HOLIDAYS   = cfg.publicHolidays   || '';
    const CUTOFF_HOUR       = 14;   // next-day shipping: order before 2PM SGT


  function getCachedCountry() {
    try {
      const raw = sessionStorage.getItem(GEO_CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      // Cache válido por 1 hora
      if (Date.now() - parsed.t > 60 * 60 * 1000) return null;
      return parsed.c;
    } catch (e) {
      return null;
    }
  }

  function setCachedCountry(code) {
    try {
      sessionStorage.setItem(
        GEO_CACHE_KEY,
        JSON.stringify({ c: code, t: Date.now() })
      );
    } catch (e) { }
  }

  function getShopifyCountry() {
    if (window.Shopify && window.Shopify.country) {
      return window.Shopify.country;
    }
  
    const match = document.cookie.match(/localization=([A-Z]{2})/);
    return match ? match[1] : null;
  }

  async function isInSingapore() {

    const country = getShopifyCountry();
    if (country === 'SG') return true;

    if (country === null) {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return tz === TIMEZONE;
      } catch (e) {
        return false;
      }
    }

    return false;
  }

  function shouldHideDelivery() {
    const inventoryStatus = document.querySelector('section.inventory .inventoryStatus');
    if (!inventoryStatus) return false; 

    if (inventoryStatus.classList.contains('out-of-stock')) return true;

    const txt = inventoryStatus.querySelector('.txt');
    if (txt && /pre-?order/i.test(txt.textContent)) return true;

    return false;
  }

  /*
   * Delivery-date logic, all in Singapore time.
   *
   *  - Deliveries run Monday to Friday and never on a Singapore public holiday.
   *  - The headline is the earliest arrival with next-day shipping (same-day is
   *    covered separately by the express line). Next-day has a 2PM cutoff:
   *      before 2PM on a delivery day -> dispatched today -> arrives the next
   *      delivery day; after 2PM, or on a weekend/holiday -> dispatched the next
   *      delivery day -> arrives the delivery day after that.
   *  - e.g. Tue 10AM -> tomorrow, Tue 4PM -> Thursday, Fri 4PM / Sat / Sun ->
   *    Tuesday. A fixed "from tomorrow onwards" was wrong for most of the week.
   *  - A public holiday on a Sunday makes the following Monday a holiday too,
   *    so in-lieu days need not be listed; weekends need not be listed either.
   */
  function sgtNow(date) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIMEZONE, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(date);
    const get = (t) => parts.find((p) => p.type === t).value;
    return { ymd: `${get('year')}-${get('month')}-${get('day')}`, hour: Number(get('hour')) };
  }

  function holidaySet() {
    const set = new Set(String(PUBLIC_HOLIDAYS).split(/[\s,]+/).filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)));
    Array.from(set).forEach((d) => {
      const dt = new Date(d + 'T00:00:00Z');
      if (dt.getUTCDay() === 0) {
        dt.setUTCDate(dt.getUTCDate() + 1);
        set.add(dt.toISOString().slice(0, 10));
      }
    });
    return set;
  }

  function isDeliveryDay(day, holidays) {
    const w = day.getUTCDay();
    return w !== 0 && w !== 6 && !holidays.has(day.toISOString().slice(0, 10));
  }

  function deliveryOutlook(now) {
    const n = sgtNow(now || new Date());
    const holidays = holidaySet();
    const today = new Date(n.ymd + 'T00:00:00Z');   // SGT calendar day, carried as UTC
    const nextDeliveryDay = (from) => {
      const d = new Date(from);
      do { d.setUTCDate(d.getUTCDate() + 1); } while (!isDeliveryDay(d, holidays));
      return d;
    };
    // the day the order is dispatched, then one delivery day for next-day shipping
    const dispatch = isDeliveryDay(today, holidays) && n.hour < CUTOFF_HOUR ? today : nextDeliveryDay(today);
    const next = nextDeliveryDay(dispatch);
    const days = Math.round((next - today) / 86400000);
    return { when: days === 1 ? 'tomorrow' : 'later', date: next, days };
  }

  function getDeliveryHeadline(now) {
    const o = deliveryOutlook(now);
    if (o.when === 'tomorrow') return HEADLINE_TOMORROW;
    // a weekday name is only unambiguous within the coming week
    const label = o.days <= 6
      ? o.date.toLocaleDateString('en-SG', { weekday: 'long', timeZone: 'UTC' })
      : o.date.toLocaleDateString('en-SG', { day: 'numeric', month: 'short', timeZone: 'UTC' });
    return HEADLINE_DAY.replace('[day]', label);
  }

  /*
   * The ship card used to be swapped in for document.querySelector('section.itsapp').
   * But `itsapp` is the theme's generic block wrapper, and the first one on the
   * page is now the Google reviews widget -- so the card was replacing the
   * reviews wrapper while the old "Need it fast?" copy stayed visible. It is now
   * placed directly before the pick-up section and replaces nothing.
   */
  function renderDeliveryCard() {
    if (document.querySelector('.dd-delivery-card')) return;
    if (shouldHideDelivery()) return;

    const pickup = document.querySelector('section.pickup-availability');
    const form = document.querySelector('product-info section.product-form');
    const anchor = pickup || (form && form.nextElementSibling);
    const parent = pickup ? pickup.parentNode : form && form.parentNode;
    if (!parent) return;

    const card = document.createElement('section');
    card.className = 'dd-delivery-card';
    card.innerHTML = `
      <div class="dd-card dd-card--ship">
        <div class="dd-card__content">
          <p class="dd-card__title">${getDeliveryHeadline()}</p>
          <div class="dd-card__express">
            <span class="dd-card__bolt" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="12" height="12"><path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" fill="currentColor"/></svg>
            </span>
            <span class="dd-card__express-text">${EXPRESS_TEXT}</span>
            <span class="dd-tip">
              <button type="button" class="dd-tip__btn" aria-label="${EXPRESS_TOOLTIP}" aria-describedby="dd-tip-express" aria-expanded="false">i</button>
              <span class="dd-tip__bubble" role="tooltip" id="dd-tip-express">${EXPRESS_TOOLTIP}</span>
            </span>
          </div>
          <div class="dd-card__standard">
            <span class="dd-card__standard-label">${STANDARD_LABEL}</span>
            <span class="dd-card__standard-value">${STANDARD_VALUE}</span>
          </div>
          <p class="dd-card__note">${CHECKOUT_NOTE}</p>
        </div>
      </div>
    `;
    parent.insertBefore(card, anchor || null);

    // tap to toggle on touch screens; hover and focus are handled in CSS
    const tip = card.querySelector('.dd-tip');
    const btn = card.querySelector('.dd-tip__btn');
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = !tip.classList.contains('is-open');
      tip.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', () => {
      tip.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    });
  }

  function renderPickupCard() {
    const pickupSection = document.querySelector('section.pickup-availability');
    if (!pickupSection || pickupSection.dataset.ddRendered === '1') return;

    const pickupEl = pickupSection.querySelector('pickup-availability');
    const isAvailable = pickupEl && pickupEl.hasAttribute('available');
    if (!isAvailable) return;

    pickupSection.dataset.ddRendered = '1';

    const card = document.createElement('div');
    card.className = 'dd-pickup-card';
    card.innerHTML = `
        <div class="dd-pickup-card__inner dd-card dd-card--pickup" id="dd-view-showroom" role="button" tabindex="0">
          <div class="dd-pickup-card__img">
            <img src="${SHOWROOM_THUMB}" alt="${PICKUP_TITLE}" loading="lazy">
          </div>
          <div class="dd-card__content dd-pickup-card__info">
            <p class="dd-card__title">${PICKUP_TITLE}</p>
            <p class="dd-pickup-card__ready">${PICKUP_READY}</p>
            <span class="dd-pickup-card__link">${PICKUP_LINK_TEXT}</span>
          </div>
        </div>
      `;

    Array.from(pickupSection.children).forEach((c) => {
      c.style.display = 'none';
    });
    pickupSection.appendChild(card);

    const inner = card.querySelector('#dd-view-showroom');
    inner.addEventListener('click', () => openShowroomDrawer());
    inner.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') openShowroomDrawer();
    });
  }

  function reorderCards() {
    const delivery = document.querySelector('.dd-delivery-card');
    const pickup = document.querySelector('section.pickup-availability');
    if (!delivery || !pickup) return;
    if (delivery.parentNode !== pickup.parentNode) return;
    if (delivery.nextElementSibling !== pickup) {
      pickup.parentNode.insertBefore(delivery, pickup);
    }
    markJoined();
  }

  /*
   * The ship and pick-up rows are rendered into different parents, so they
   * cannot share a wrapper. When both are present they are flagged and the CSS
   * joins their borders into one container; alone, each stays fully rounded.
   */
  function markJoined() {
    const delivery = document.querySelector('.dd-delivery-card');
    const pickupCard = document.querySelector('.dd-pickup-card');
    const joined = !!(delivery && pickupCard);
    if (delivery) delivery.classList.toggle('dd-joined-top', joined);
    if (pickupCard) pickupCard.classList.toggle('dd-joined-bottom', joined);
  }

  function buildDrawer() {
    if (document.querySelector('.dd-drawer')) return;

    const overlay = document.createElement('div');
    overlay.className = 'dd-drawer__overlay';
    overlay.setAttribute('aria-hidden', 'true');

    const drawer = document.createElement('aside');
    drawer.className = 'dd-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'dd-drawer-title');
    drawer.setAttribute('tabindex', '-1');
    drawer.innerHTML = `
      <div class="dd-drawer__header">
        <h3 class="dd-drawer__title" id="dd-drawer-title">${DRAWER_TITLE}</h3>
        <button class="dd-drawer__close" type="button" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18 6 6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <div class="dd-drawer__image">
        <img src="${SHOWROOM_IMG}" alt="${SHOWROOM_NAME}" loading="lazy">
      </div>

      <div class="dd-drawer__body">
        <div class="dd-drawer__store-block">
          <div class="dd-drawer__store-heading">
            <h4 class="dd-drawer__store-name">${SHOWROOM_NAME}</h4>
            <p class="dd-drawer__store-address">
              ${SHOWROOM_ADDRESS_LINE_1}<br>
              ${SHOWROOM_ADDRESS_LINE_2}
            </p>
          </div>

          <p class="dd-drawer__tagline">${SHOWROOM_TAGLINE}</p>

          <div class="dd-drawer__hours">
            <p class="dd-drawer__hours-title">${DRAWER_HOURS_TITLE}</p>
            <div class="dd-drawer__hours-row">
              <span class="dd-drawer__hours-label">${SHOWROOM_HOURS_LABEL}</span>
              <span class="dd-drawer__hours-value">${SHOWROOM_HOURS_VALUE}</span>
            </div>
          </div>
        </div>

        <a class="dd-drawer__cta" href="${SHOWROOM_URL}" target="_blank" rel="noopener noreferrer">
          ${DRAWER_CTA}
        </a>
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    overlay.addEventListener('click', closeShowroomDrawer);
    drawer.querySelector('.dd-drawer__close').addEventListener('click', closeShowroomDrawer);
    document.addEventListener('keydown', onEscClose);
  }

  function onEscClose(e) {
    if (e.key === 'Escape') closeShowroomDrawer();
  }

  function openShowroomDrawer() {
    buildDrawer();
    requestAnimationFrame(() => {
      const overlay = document.querySelector('.dd-drawer__overlay');
      const drawer = document.querySelector('.dd-drawer');
      if (overlay) overlay.classList.add('is-open');
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.focus();
      }
      document.documentElement.style.overflow = 'hidden';
    });
  }

  function closeShowroomDrawer() {
    const overlay = document.querySelector('.dd-drawer__overlay');
    const drawer = document.querySelector('.dd-drawer');
    if (overlay) overlay.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onEscClose);

    setTimeout(() => {
      if (overlay) overlay.remove();
      if (drawer) drawer.remove();
    }, 300);
  }

  let geoChecked = false;
  let geoAllowed = false;

  async function checkGeoOnce() {
    if (geoChecked) return geoAllowed;
    geoAllowed = await isInSingapore();
    geoChecked = true;
    return geoAllowed;
  }

  async function init() {
    const allowed = await checkGeoOnce();
    if (!allowed) return;
    renderDeliveryCard();
    renderPickupCard();
    reorderCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const mo = new MutationObserver(() => {
    if (!geoChecked) return;
    if (!geoAllowed) return;

    if (shouldHideDelivery()) {
      const existing = document.querySelector('.dd-delivery-card');
      if (existing) existing.remove();
    } else {
      if (!document.querySelector('.dd-delivery-card')) {
        renderDeliveryCard();
      }
    }

    renderPickupCard();
    reorderCards();
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();